<template>
  <div class="lang-switcher" :class="{ 'is-open': open }">
    <button class="lang-trigger" @click.stop="open = !open" :title="label($locale)">
      <Flag :code="$locale" />
      <span class="caret"></span>
    </button>

    <div class="lang-menu" v-show="open">
      <button v-for="code in $locales" :key="code"
              class="lang-item"
              :class="{ 'is-current': code === $locale }"
              @click.stop="pick(code)"
              :title="label(code)">
        <Flag :code="code" />
        <span class="lang-name">{{ label(code) }}</span>
      </button>
    </div>
  </div>
</template>

<script>

// Bayraklar gömülü SVG. Emoji bayrak (TR/FR/GB) kullanmadım: Windows
// bunları render etmiyor, iki harf olarak görünüyorlar. Görsel dosya da
// istemedim, böylece bileşen tek başına taşınabiliyor.
const Flag = {
  props: { code: { type: String, required: true } },
  template: `
    <svg class="flag" viewBox="0 0 24 16" width="24" height="16" aria-hidden="true">
      <defs>
        <clipPath :id="'fc' + uid"><rect x="0" y="0" width="24" height="16" rx="2"/></clipPath>
      </defs>
      <g :clip-path="'url(#fc' + uid + ')'">

        <g v-if="code === 'tr'">
          <rect width="24" height="16" fill="#E30A17"/>
          <circle cx="9.6" cy="8" r="3.9" fill="#fff"/>
          <circle cx="11.1" cy="8" r="3.1" fill="#E30A17"/>
          <path fill="#fff" d="M14.3 8 L17.6 6.9 L15.6 9.7 L15.6 6.3 L17.6 9.1 Z"/>
        </g>

        <g v-else-if="code === 'fr'">
          <rect width="24" height="16" fill="#fff"/>
          <rect width="8" height="16" fill="#0055A4"/>
          <rect x="16" width="8" height="16" fill="#EF4135"/>
        </g>

        <g v-else>
          <rect width="24" height="16" fill="#012169"/>
          <path d="M0 0 L24 16 M24 0 L0 16" stroke="#fff" stroke-width="3.4"/>
          <path d="M0 0 L24 16 M24 0 L0 16" stroke="#C8102E" stroke-width="1.8"/>
          <path d="M12 0 V16 M0 8 H24" stroke="#fff" stroke-width="5.4"/>
          <path d="M12 0 V16 M0 8 H24" stroke="#C8102E" stroke-width="3.2"/>
        </g>

      </g>
      <rect x="0.5" y="0.5" width="23" height="15" rx="2"
            fill="none" stroke="rgba(0,0,0,0.18)" stroke-width="1"/>
    </svg>
  `,
  data() {
    // Her bayrağın clipPath id'si benzersiz olmalı; aynı sayfada birden
    // fazla bayrak varsa aynı id'ler birbirini eziyor
    return { uid: Math.random().toString(36).slice(2, 8) };
  }
};

export default {
  name: 'LanguageSwitcher',
  components: { Flag },
  data() {
    return { open: false };
  },
  mounted() {
    document.addEventListener('click', this.onOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onOutside);
  },
  methods: {
    onOutside() {
      if (this.open) this.open = false;
    },
    pick(code) {
      this.$setLocale(code);
      this.open = false;
    },
    label(code) {
      return { tr: 'Türkçe', en: 'English', fr: 'Français' }[code] || code;
    }
  }
};
</script>

<style scoped>
.lang-switcher {
  position: relative;
  display: inline-block;
}

/* Zemin şeffaf: koyu başlık üzerinde de açık bir sayfada da oturuyor.
   Sınır ve ok currentColor'dan türediği için yazı rengini takip ediyor. */
.lang-trigger {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: transparent;
  border: 1px solid currentColor;
  border-radius: 999px;
  padding: 4px 10px 4px 7px;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
  transition: opacity 0.15s, background-color 0.15s;
}

.lang-trigger:hover,
.is-open .lang-trigger {
  opacity: 1;
  background: rgba(127, 127, 127, 0.16);
}

.caret {
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid currentColor;
  opacity: 0.8;
}

.lang-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  min-width: 152px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(20, 20, 40, 0.18);
  padding: 4px;
  z-index: 40;
}

.lang-item {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  background: transparent;
  border: 0;
  border-radius: 6px;
  padding: 7px 10px;
  cursor: pointer;
  font-size: 13px;
  color: #363636;
  text-align: left;
}

.lang-item:hover {
  background: #f2f4f8;
}

.lang-item.is-current {
  font-weight: 600;
  background: #eef2fb;
}

.flag {
  display: block;
  flex: 0 0 auto;
}

.lang-name {
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/Components/LanguageSwitcher.vue